import {Component, input} from '@angular/core';
import {TrackingResultMetrics} from '../../interfaces/tracking.interfaces';
import {distanceInMetersToPrettyString, timeToPrettyString} from '../../functions/prettiers.functions';
import {msToTimeSpan} from '../../functions/time.functions';
import {TranslocoDirective} from '@ngneat/transloco';
import {NgClass} from '@angular/common';
import {SvgWrapperComponent} from '../svg-wrapper/svg-wrapper.component';

@Component({
    selector: 'lib-metrics-view',
    imports: [
        TranslocoDirective,
        NgClass,
        SvgWrapperComponent
    ],
    templateUrl: './metrics-view.component.html',
    styleUrl: './metrics-view.component.scss'
})
export class MetricsViewComponent {
  metrics = input<TrackingResultMetrics>({
    steps: 0,
    distance: 0,
    calories: 0,
    time: 0,
  });
  showOnlyDistAndTime = input<boolean>(false);

  protected readonly distanceInMetersToPrettyString = distanceInMetersToPrettyString;
  protected readonly timeToPrettyString = timeToPrettyString;
  protected readonly msToTimeSpan = msToTimeSpan;
}
